var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleche300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.213,
    height: 102.053,
    viewBox: "0 0 82.213 102.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    transform: "translate(-724.392 -593.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M4868.066-548H4982.5",
    transform: "matrix(0.616, 0.788, -0.788, 0.616, -2698.91, -2898.877)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_5",
    "data-name": "Polygone 5",
    d: "M3.5,0,7,6H0Z",
    transform: "matrix(-0.788, 0.616, -0.616, -0.788, 806.605, 691.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_6",
    "data-name": "Polygone 6",
    d: "M3.5,0,7,6H0Z",
    transform: "matrix(0.777, -0.629, 0.629, 0.777, 724.392, 598.371)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleche300);
export default __webpack_public_path__ + "static/media/fleche-300.2ee58c524166341364739f2761cd1127.svg";
export { ForwardRef as ReactComponent };